import { useRef, useState, useEffect } from 'react';
import styled from '@emotion/styled';

import { BasicFlex } from '../../../../utils/Common';


import { usePageData } from '../../../../contexts/PageData';

import { TextField, Button } from '@mui/material';


const Hours = () => {

  const [hours, setHours] = useState({ start: 0, end: 24 });

  const handleChange = (e, field) => {
    let val = e.target.value;
    setHours({ ...hours, [field]: val });
  }

  const { data, modifySetting } = usePageData() || {};

  let values = data?.data || {};

  let { start, end } = values?.display_hours || { start: 0, end: 24 };

  useEffect(() => {
    setHours({ start, end });
  }, [start, end]);

  const updateSetting = () => {
    console.log(hours?.start, hours?.end, "values");
    let sh = Math.min(Math.max((+hours?.start || 0), 0), 24);
    let eh = Math.max(Math.min((+hours?.end || 24), 24), 0);

    if (sh > eh) {
      let temp = eh;
      eh = sh;
      sh = temp;
    }
    modifySetting({ start: sh, end: eh }, "display_hours", data?.setting_id);
  }

  return (
    <BasicFlex dir="column" gap="1rem">
      <BasicFlex justify="flex-start" gap="1rem">
        <TextField
          type="number"
          value={hours?.start}
          onChange={(e) => handleChange(e, "start")}
          variant="outlined"
          size='small'
          sx={{width: "10rem"}}
        />
        <TextField
          type="number"
          value={hours?.end}
          onChange={(e) => handleChange(e, "end")}
          variant="outlined"
          size='small'
          sx={{width: "10rem"}}
        />
      </BasicFlex>
      <Button variant="outlined" onClick={updateSetting}>Update Setting</Button>
    </BasicFlex>
  )
};

export default Hours;